import '../css/app.css';

import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { ProdDbWarning } from './components/prod-db-warning';
import { initializeTheme } from './hooks/use-appearance';
import i18n from './i18n';

let appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
  title: (title) => (title ? `${title} - ${appName}` : appName),
  resolve: (name) =>
    resolvePageComponent(
      `./pages/${name}.tsx`,
      import.meta.glob('./pages/**/*.tsx'),
    ),
  setup({ el, App, props }) {
    // Use brand name from shared props as the title suffix
    const brandName = (
      props.initialPage.props as Record<string, unknown> & {
        brand?: { name?: string };
      }
    )?.brand?.name;
    if (brandName) appName = brandName;
    // Sync i18n locale with the server locale on every Inertia navigation
    const getLocale = (page: { props: Record<string, unknown> }) =>
      (page.props.locale as string) || 'en';

    i18n.changeLanguage(getLocale(props.initialPage));

    router.on('navigate', (event) => {
      const locale = getLocale(event.detail.page);
      if (i18n.language !== locale) {
        i18n.changeLanguage(locale);
      }
    });

    const prodDbWarning = Boolean(
      (props.initialPage.props as Record<string, unknown>).prod_db_warning,
    );

    createRoot(el).render(
      <StrictMode>
        <I18nextProvider i18n={i18n}>
          <App {...props} />
          {prodDbWarning && <ProdDbWarning />}
        </I18nextProvider>
      </StrictMode>,
    );
  },
  progress: {
    color: '#4B5563',
  },
});

// This will set light / dark mode on load...
initializeTheme();
